export default __webpack_public_path__ + "static/ensnamepicker-a0702291aceee2c211c3ff7a9ff572c7.jpg";